<a class="checkbox-btn" (click)="toggle()" href="#">
  <t-icon name="check_box" *ngIf="checked"></t-icon>
  <t-icon name="check_box_outline_blank" *ngIf="!checked"></t-icon>
  <span>{{ label }}</span>
</a>